export const Platform = {
    IOS: 'ios',
    ANDROID: 'android',
};

export function isAppBrowserAgent() {
    const userAgent = (window.navigator && window.navigator.userAgent) || '';
    return userAgent.includes('PerpayAppBrowser');
}

export function isIosAgent() {
    const userAgent = (window.navigator && window.navigator.userAgent) || '';
    return userAgent.includes('PerpayAppBrowserIos');
}

export function isAndroidAgent() {
    const userAgent = (window.navigator && window.navigator.userAgent) || '';
    return userAgent.includes('PerpayAppBrowserAndroid');
}

/**
 * @returns {'ios' | 'android' | null}
 */
export function getMobileBrowserPlatform() {
    if (!window.navigator) {
        return null;
    }

    if (!window.navigator.userAgent) {
        return null;
    }

    const userAgent = window.navigator.userAgent.toLowerCase();

    const isAndroid = /android/i.test(userAgent);
    if (isAndroid) {
        return Platform.ANDROID;
    }

    const isIOS = /iphone|ipad|ipod/i.test(userAgent);
    if (isIOS) {
        return Platform.IOS;
    }

    return null;
}
